import { OrderDirection } from "@/constants/orderDirection";
import type { EnumUnion } from "@dresscode-frontend/utility-types";
import { z } from "zod";

// テーブルカラムの定数
export const Columns = {
  ASSIGNED_DEVICE: "LICENSE_ASSIGNED_DEVICE",
  DEVICE_USER: "DEVICE_USER",
  DEVICE_PLACEMENT: "DEVICE_PLACEMENT",
  DEVICE_RESPONSIBLE_PERSON: "DEVICE_RESPONSIBLE_PERSON",
  NOTES: "NOTES",
} as const;
export type Columns = EnumUnion<typeof Columns>;

// YAGNI: 初期スコープでは未割り当てのライセンスは表示しない
export const LicenseDeviceCategoryFilterKey = {
  ASSIGNED: "ASSIGNED",
} as const;
export type LicenseDeviceCategoryFilterKey = EnumUnion<
  typeof LicenseDeviceCategoryFilterKey
>;

export const TabKey = {
  ASSIGNED: LicenseDeviceCategoryFilterKey.ASSIGNED,
} as const;
export type TabKey = EnumUnion<typeof TabKey>;

export const TabKeySchema = z.nativeEnum(TabKey);

export const SearchSchema = z.object({
  sortOrder: z.nativeEnum(OrderDirection).default(OrderDirection.ASC),
  category: z
    .nativeEnum(LicenseDeviceCategoryFilterKey)
    .default(LicenseDeviceCategoryFilterKey.ASSIGNED),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.enum([Columns.ASSIGNED_DEVICE]).optional(),
});
